import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { APP_CONFIG } from '../tokens/app-config.token';
import { Environment } from '../../../environments/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  constructor(
    @Inject(APP_CONFIG) private readonly appConfig: Environment,
    @Inject(PLATFORM_ID) private readonly platformId: string,
  ) {}

  initFavicon(): void {
    /* Adding Favicon img from Datanyze bucket to header - Only in browser */
    if (isPlatformBrowser(this.platformId)) {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/x-icon';
      link.href = `${this.appConfig.icons_url}/favicon-icon.png`;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }
}
